module.exports = __webpack_public_path__ + "static/banner-yellow-4d1a4bc1fd21faa2188ae2b98d4e65dc.svg";